var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48989 6.77376L9.82659 10L11 8.83855L7.6633 5.61231L6.48989 6.77376ZM8.55865 3.97769C8.34176 3.97769 8.10819 3.9508 7.92467 3.87552L1.5905 9.97311L0.417088 8.83855L4.53792 4.85952L3.55359 3.90241L3.15319 4.2788L2.34682 3.52063V5.05848L1.95753 5.43487L0 3.52063L0.389282 3.14424H1.95197L1.17341 2.38607L3.15319 0.471838C3.80384 -0.157279 4.84934 -0.157279 5.5 0.471838L4.32659 1.63328L5.11072 2.38607L4.71588 2.76785L5.71132 3.72496L6.72346 2.71407C6.6456 2.53663 6.61224 2.31079 6.61224 2.11184C6.61224 1.05256 7.47978 0.219115 8.55865 0.219115C8.88675 0.219115 9.17593 0.294394 9.43731 0.444952L7.95248 1.88063L8.78665 2.68719L10.2715 1.25151C10.4272 1.50423 10.5051 1.77309 10.5051 2.11184C10.5051 3.14424 9.64307 3.97769 8.55865 3.97769Z",
    fill: "#234BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.0b40834005fa0e1b1f31eef1707b5719.svg";
export { ForwardRef as ReactComponent };